import { render } from "./uploadStock.vue?vue&type=template&id=f60953ee&scoped=true"
import script from "./uploadStock.vue?vue&type=script&lang=js"
export * from "./uploadStock.vue?vue&type=script&lang=js"

import "./uploadStock.vue?vue&type=style&index=0&id=f60953ee&scoped=true&lang=css"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f60953ee"]])

export default __exports__